/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ConvertToTemplateAPI
 * @hideconstructor
 * @classdesc A utility feature to convert dashboard specs into dashboard templates
 */
define([], () => {
	class ConvertToTemplateAPI{
		/**
		 * @description Converts a given dashboard spec into a dashboard template spec
		 * @param {object} dashboardSpec The dashboard spec to be converted into a dashboard template spec
		 * @returns {Promise} Resolves to the converted dashboard template spec
		 */
		convertToTemplate(){}
	}

	return ConvertToTemplateAPI;
});
